<template>
  <div :class="`${$colorMode.value}`">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup>
import { useSettings } from '~/composables/useSettings'
import { useHead } from '#app'
import { computed, watch } from 'vue'

const colorMode = useColorMode()
// Sayfa yüklendiğinde dark mode'u kontrol et
onMounted(() => {
  if (colorMode.preference === 'dark') {
    document.documentElement.classList.add('dark')
  }
})

// Site ayarlarını al
const { siteSettings, isLoading } = useSettings()

// Site başlığını dinamik olarak ayarla
const title = computed(() => siteSettings.site_title || 'Teknopark')
const favicon = computed(() => siteSettings.favicon || '/favicon.ico')

// Dinamik head ayarları
useHead({
  title,
  link: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: favicon
    }
  ],
  meta: [
    {
      name: 'description',
      content: computed(() => siteSettings.site_description || 'Teknopark resmi web sitesi')
    }
  ]
})
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.3s ease-in-out;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

/* Dark mode için temel stiller */
.dark {
  background-color: #1a1a1a;
  color: #ffffff;
}

html.dark {
  color-scheme: dark;
}
</style>
